import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text, Flex } from '@atlaskit/primitives';
import { getRepoName } from '@atlassian/jira-autodev/src/common/utils';
import { useIntl } from '@atlassian/jira-intl';
import type { planningSuccess_periscope_AutoDevJobsPlanningSuccess$key } from '@atlassian/jira-relay/src/__generated__/planningSuccess_periscope_AutoDevJobsPlanningSuccess.graphql';
import { TaskItem } from '../../../../common/ui/task-item';
import { TaskTypeItem } from '../../../../common/ui/task-type';
import { useWorkSuggestionsContainer } from '../../../../services/periscope-container';
import { useWorkSuggestionsAction } from '../../../../services/use-work-suggestions-action';
import { messages } from './messages';

export const AutoDevJobsPlanningSuccess = ({
	fragmentRef,
}: {
	fragmentRef: planningSuccess_periscope_AutoDevJobsPlanningSuccess$key;
}) => {
	const { formatMessage } = useIntl();
	const data = useFragment(
		graphql`
			fragment planningSuccess_periscope_AutoDevJobsPlanningSuccess on WorkSuggestionsAutoDevJobsPlanSuccessTask {
				id
				__typename
				issue {
					id
					key
					summary
					iconUrl
					webUrl
				}
				repoUrl
			}
		`,
		fragmentRef,
	);
	const { snooze, remove } = useWorkSuggestionsAction();
	const [{ showReactionsButtonForSuggestions }, { hideSuggestionsReactionsButton }] =
		useWorkSuggestionsContainer();

	const renderInfoContent = () => (
		<Flex alignItems="center" columnGap="space.100">
			{data.issue.iconUrl && (
				<img width="22px" height="22px" src={data.issue.iconUrl} alt="Issue icon" />
			)}
			<Flex rowGap="space.050" direction="column">
				<Flex columnGap="space.050">
					<Text>{data.issue.key}</Text>
					<Text>{data.issue.summary}</Text>
				</Flex>
				{data.repoUrl && (
					<Text color="color.text.subtle" size="small">
						{getRepoName(data.repoUrl)}
					</Text>
				)}
			</Flex>
		</Flex>
	);
	return (
		<TaskTypeItem
			onRemove={() => remove({ id: data.id, typename: data.__typename })}
			onSnooze={() => snooze({ id: data.id, typename: data.__typename })}
			showReactionsButton={
				showReactionsButtonForSuggestions[data.id] === true ||
				showReactionsButtonForSuggestions[data.id] == null
			}
			url={`${data.issue.webUrl}?showAutodev=true`}
			onReactionsButtonClick={() => hideSuggestionsReactionsButton(data.id)}
			suggestionType={data.__typename}
			id={data.id}
			actionButtonTitle={formatMessage(messages.actionButtonNonFinal)}
		>
			<TaskItem taskInfoContent={renderInfoContent()} />
		</TaskTypeItem>
	);
};
